/**
 * VECTOR KNOWLEDGE SERVICE (SIMPLIFICADO)
 * Sistema de busca otimizado para browser
 * ChromaDB requer backend - não funciona no navegador
 */

import { simpleKnowledgeService, type SimpleSearchResult as SearchResult } from './simple-knowledge-service';
import { supabase } from '../lib/supabase';

export interface KnowledgeDocument {
  id: string;
  assistant_id: string;
  title: string;
  content: string;
  content_type: string;
  size: number;
  created_by: string;
  metadata: any;
  created_at: string;
  updated_at: string;
}

class VectorKnowledgeService {
  /**
   * Adicionar documento
   */
  async addDocument(
    assistantId: string,
    title: string,
    content: string,
    userId: string,
    contentType: string = 'text',
    metadata: any = {}
  ): Promise<KnowledgeDocument | null> {
    return await simpleKnowledgeService.addDocument(
      assistantId,
      title,
      content,
      userId,
      contentType,
      metadata
    );
  }

  /**
   * Buscar documentos
   */
  async searchDocuments(
    assistantId: string,
    query: string,
    limit: number = 3
  ): Promise<SearchResult[]> {
    return await simpleKnowledgeService.searchDocuments(assistantId, query, limit);
  }

  /**
   * Listar todos os documentos
   */
  async listDocuments(assistantId: string): Promise<KnowledgeDocument[]> {
    return await simpleKnowledgeService.listDocuments(assistantId);
  }

  /**
   * Deletar documento
   */
  async deleteDocument(documentId: string, assistantId: string): Promise<void> {
    return await simpleKnowledgeService.deleteDocument(documentId);
  }

  /**
   * Obter estatísticas
   */
  async getStats(assistantId: string): Promise<{
    totalDocuments: number;
    totalSize: number;
  }> {
    return await simpleKnowledgeService.getStats(assistantId);
  }
}

export const vectorKnowledgeService = new VectorKnowledgeService();

